module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Collection Name"
    },
    model: {
      value: (_vm.collection.name),
      callback: function($$v) {
        _vm.$set(_vm.collection, "name", $$v)
      },
      expression: "collection.name"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Log Changes",
      "hide-details": "",
      "single-line": ""
    },
    model: {
      value: (_vm.collection.logChanges),
      callback: function($$v) {
        _vm.$set(_vm.collection, "logChanges", $$v)
      },
      expression: "collection.logChanges"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aec2fb54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/system/CollectionDialog.vue
// module id = 2642
// module chunks = 1